<template>
  <div id="home">
    <div id="page" class="container">
      <div class="hello">
        <h1>Commandes en production</h1>
        <div class="row">
          <div class="col-lg-4 col-12">
            <div class="card">
              <div class="card-body row">
                <div class="col-3 text-center">
                  <i class="fas fa-cart-arrow-down colorpurple fa-lg"></i>
                </div>
                <div class="col-9">
                  <h4>Commandes</h4>
                  {{orders.length}} commandes en attente de BAT
                </div>
              </div>
            </div>
          </div>
        </div>

      <div class="card mb-4 bloctabprod" id="bloctaborder">
        <div class="card-body">
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Recherche"
                single-line
                hide-details
              ></v-text-field>
              <v-select
                :items="printers"
                multiple
                label="Machine"
                item-text='1'
                item-value='1'
                v-model="filters.printed_with"
                @change="filterPrinter"
                ></v-select>
            </v-card-title>
          <table class="table" style="font-size:14px;">
            <thead>
              <tr>
                <th scope="col">Action</th>
                <th scope="col">Visuel</th>
                <th scope="col">N° commande</th>
                <th scope="col">Client</th>
                <th scope="col">Ref</th>
                <th scope="col">Produit</th>
                <th scope="col" width="70px">Qté</th>
                <th scope="col">Machine</th>
                <th scope="col">Statut</th>
                <th scope="col" width="95px">#</th>
              </tr>
            </thead>
            <tbody  v-for="(o,$index) in orders" :key="o.id">
              <OLine :class="'linecolor-'+ $index % 2" v-for="item in o.of.TAssetOFLine" :key="item.id" :o="o" :item="item" @anItemIsEnded="itemindex => anItemIsEnded($index,itemindex)"/>
            </tbody>
          </table>
        </v-card>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
// @ is an alias to /src
import axios from 'axios';
import moment from 'moment'
import OLine from "@/components/OfLineArray.vue"

export default {
  name: 'Home',
  components: {
      OLine,
  },
  data(){
    return {
      selected: [],
      printers: [],
      search: "",
      orders : [],
      fullOrdersList: [],
      ofdone: 10,
      up: 0,
      oftotal: 70,
      sortBy: 'date_commande',
      sortDesc: true,
      footerProps: {
        'items-per-page-options': [25, 50, 100, 500],
      },
      filters: {
        printed_with: ''
      },
    }
  },
  mounted () {
    axios
      .get(
        "https://crm.bonbonprint.fr/api/index.php/workstation/listWk",
        {
          headers: {
            'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9'
          }
        }
      )
      .then(response => {
        this.printers = Object.keys(response.data).map((key) => [Number(key),response.data[key]]);
      });
    axios
      .get(
        "https://crm.bonbonprint.fr/api/index.php/orders/orderslistwithofs?sortfield=t.date_creation&sortorder=ASC&limit=200&sqlfilters=(t.fk_statut:=:'2')",
        {
          headers: {
            'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9' //the token is a variable which holds the token
          }
        }
      )
      .then(response => {
        console.log(response);
        this.orders = response.data.olist
        this.fullOrdersList = response.data.olist
      })
  },
  filters: {
    moment: function (date) {
      return (date) ? moment(date*1000).format('DD/MM/YYYY') : "N.C.";
    }
  },
  methods: {
    handleprint : function(r){
      var orderIndex = this.orders.findIndex((obj => parseInt(obj.of.id) == r.data.fk_assetOf))
      var objIndex = this.orders[orderIndex].of.TAssetOFLine.findIndex((obj => parseInt(obj.id) == r.data.id));

      var dack = this.orders[orderIndex].of.TAssetOFLine[objIndex];
      this.orders[orderIndex].of.TAssetOFLine[objIndex] = r.data
      this.orders[orderIndex].of.TAssetOFLine[objIndex].orderline = dack.orderline

      this.$forceUpdate();
   },
   handleCloseOf : function(r){
     var orderIndex = this.orders.findIndex((obj => parseInt(obj.of.id) == r))
     this.orders.splice(orderIndex, 1)
   },


  filterPrinter() {
    if (this.filters.printed_with !== []) {
      this.orders = this.fullOrdersList.filter((item) => item.of.TAssetOFLine.some( e => this.filters.printed_with.includes(e.machine)))
    }
    else{
      this.orders = this.fullOrdersList;
    }
  },
  anItemIsEnded(index,itemid) {
    this.orders[index].of.TAssetOFLine = this.orders[index].of.TAssetOFLine.filter(function( obj ) {
      return obj.id != itemid;
    });
    if(this.orders[index].of.TAssetOFLine.length == 0){
      axios.post(
        "https://crm.bonbonprint.fr/api/index.php/of/terminersimpleOF",
        {ofid:parseInt(this.orders[index].of.id),lines:[]},
        {
          headers: {
            'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9' //the token is a variable which holds the token
          }
        }
      )
      .then(response => {
        console.log(response);
        this.orders.slice(index);
        var ref = this.orders[index].ref;
        this.$notify({
          group: 'foo',
          title: 'Commande terminée',
          text: "L'ensemble des OFs de la commande "+ref+" sont terminés",
          duration:-1
        });
      });
    }
  }

 },
 watch : {
   orders: {
     handler: function () {
       this.$forceUpdate()
     },
     deep: true
    },
  },

}
</script>
<style media="screen">
  .linecolor-0{
    background: #F2E6E7;
  }
  .linecolor-1{
    /*background: #c0e0f3;*/
  }
</style>
